export default __webpack_public_path__ + "static/media/baunebakken-floorplan-4-rooms.db526d17.png";